<h2 mat-dialog-title>{{ isEdit ? 'Institution bearbeiten' : 'Institution anlegen' }}</h2>
<mat-dialog-content class="dialog-content">
    <div class="one-row">
        <mat-form-field class="flex">
            <mat-label>Bezeichnung</mat-label>
            <input matInput [formControl]="bezeichnungCtrl" />
        </mat-form-field>
        <mat-form-field class="flex">
            <mat-label>Kurzname</mat-label>
            <input matInput [formControl]="kurzCtrl" />
        </mat-form-field>
    </div>
    <div class="one-row">
        <mat-form-field class="flex">
            <mat-label>Art</mat-label>
            <mat-select [formControl]="artCtrl">
                <mat-option *ngFor="let a of arten" [value]="a.id">{{ a.label }}</mat-option>
            </mat-select>
        </mat-form-field>
        <div class="flex" style="padding-top: 12px">
            <mat-checkbox [formControl]="aktivCtrl">Aktiv</mat-checkbox>
        </div>
    </div>
    <div class="one-row">
        <mat-form-field class="flex">
            <mat-label>Straße</mat-label>
            <input matInput [formControl]="strasseCtrl" />
        </mat-form-field>
        <mat-form-field style="width: 100px">
            <mat-label>PLZ</mat-label>
            <input matInput [formControl]="plzCtrl" />
        </mat-form-field>
        <mat-form-field class="flex">
            <mat-label>Ort</mat-label>
            <input matInput [formControl]="ortCtrl" />
        </mat-form-field>
    </div>
    <p class="hint">Debitor (Typ 6) und Kreditor (Typ 5). Ohne Auswahl: neue Nummer anlegen.</p>
    <div class="one-row">
        <div class="flex">
            <kiene-autocomplete
                [apiUrl]="'fibu_konto/'"
                [displayFields]="['konto_nr', 'bezeichnung']"
                [focus]="false"
                [kieneObject]="debitor"
                [params]="debitorParams"
                [placeholder]="'Debitor-Konto'"
                [required]="false"
                (elementSelected)="debitor = $event"
            ></kiene-autocomplete>
        </div>
        <mat-form-field style="width: 140px">
            <mat-label>Neue Debitor-Nr.</mat-label>
            <input matInput [formControl]="kontoNrCtrl" placeholder="100xxx" />
        </mat-form-field>
    </div>
    <div class="one-row">
        <div class="flex">
            <kiene-autocomplete
                [apiUrl]="'fibu_konto/'"
                [displayFields]="['konto_nr', 'bezeichnung']"
                [focus]="false"
                [kieneObject]="kreditor"
                [params]="kreditorParams"
                [placeholder]="'Kreditor-Konto'"
                [required]="false"
                (elementSelected)="kreditor = $event"
            ></kiene-autocomplete>
        </div>
        <mat-form-field style="width: 140px">
            <mat-label>Neue Kreditor-Nr.</mat-label>
            <input matInput [formControl]="kreditorKontoNrCtrl" placeholder="700xxx" />
        </mat-form-field>
    </div>
    <div class="one-row">
        <div class="flex">
            <kiene-autocomplete
                [apiUrl]="'fibu_konto/'"
                [displayFields]="['konto_nr', 'bezeichnung']"
                [focus]="false"
                [kieneObject]="erloes"
                [params]="erloesParams"
                [placeholder]="'Default-Erlös 86xx (nie 8400)'"
                [required]="false"
                (elementSelected)="erloes = $event"
            ></kiene-autocomplete>
        </div>
    </div>
    <mat-form-field class="full">
        <mat-label>Kommentar</mat-label>
        <textarea matInput rows="2" [formControl]="kommentarCtrl"></textarea>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Abbrechen</button>
    <button mat-flat-button color="primary" type="button" [disabled]="!isValid()" (click)="save()">Speichern</button>
</mat-dialog-actions>
